module.exports = __webpack_public_path__ + "static/img/891.6488b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/891.jpg
// module id = XibK
// module chunks = 0